var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "url(#paint0_linear_3791_13170)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 25C49.7956 25 50.5587 25.3161 51.1213 25.8787C51.6839 26.4413 52 27.2044 52 28V52C52 52.7956 51.6839 53.5587 51.1213 54.1213C50.5587 54.6839 49.7956 55 49 55H31C30.2044 55 29.4413 54.6839 28.8787 54.1213C28.3161 53.5587 28 52.7956 28 52V28C28 27.2044 28.3161 26.4413 28.8787 25.8787C29.4413 25.3161 30.2044 25 31 25H49ZM40 41.5H35.5C35.1022 41.5 34.7206 41.658 34.4393 41.9393C34.158 42.2206 34 42.6022 34 43C34 43.3978 34.158 43.7794 34.4393 44.0607C34.7206 44.342 35.1022 44.5 35.5 44.5H40C40.3978 44.5 40.7794 44.342 41.0607 44.0607C41.342 43.7794 41.5 43.3978 41.5 43C41.5 42.6022 41.342 42.2206 41.0607 41.9393C40.7794 41.658 40.3978 41.5 40 41.5ZM44.5 34H35.5C35.1177 34.0004 34.75 34.1468 34.4719 34.4093C34.1939 34.6717 34.0266 35.0304 34.0042 35.4121C33.9818 35.7938 34.106 36.1696 34.3514 36.4627C34.5968 36.7559 34.9449 36.9443 35.3245 36.9895L35.5 37H44.5C44.8823 36.9996 45.25 36.8532 45.5281 36.5907C45.8061 36.3283 45.9734 35.9696 45.9958 35.5879C46.0182 35.2062 45.894 34.8304 45.6486 34.5373C45.4032 34.2441 45.0551 34.0557 44.6755 34.0105L44.5 34Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3791_13170",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AB2AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AB2AE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCircle);
export default __webpack_public_path__ + "static/media/file-circle.b630db6f2dddb0d8ca77ab430f2dc368.svg";
export { ForwardRef as ReactComponent };